import { Col, Row } from "antd";
import { Button, Descriptions, Form, FormInstance, Input, message, Modal, Select, Space } from "antd/es";
import { useEffect, useRef, useState, useImperativeHandle, forwardRef } from "react";
import Server from "../../../server/Server";
import URL from "../../../server/URL";

interface IAttributeRuleEdit {
    attributeRuleID?: string
    viewMode: number,
    reLoad: () => void
}

const AttributeRuleEdit = forwardRef((props: IAttributeRuleEdit, ref: any) => {
    const { reLoad } = props;
    const formRef = useRef<FormInstance>(null);
    const [visible, setVisible] = useState(false);
    const [viewMode, setViewMode] = useState<number>(0);
    const [attributeRuleID, setAttributeRuleID] = useState<any>();
    const [attributeRuleName, setAttributeRuleName] = useState<any>();

    useImperativeHandle(ref, () => ({
        setVisible
    }))

    useEffect(() => {
        if (visible) {
            setViewMode(props.viewMode);
            if (props.attributeRuleID) {
                setAttributeRuleID(props.attributeRuleID);
            }
            else {
                setData(null);
            }
        }
    }, [visible])

    useEffect(() => {
        if (attributeRuleID) {
            getAttributeRule();
        }
    }, [attributeRuleID])

    const getAttributeRule = () => {
        var params = {
            attributeRuleID: attributeRuleID
        };
        Server.Post(URL.AttributeRule.GetAttributeRule, params, false).then((response: any) => {
            if (response.isSuccess) {
                setData(response);
            }
        })
    }

    const setData = (record: any) => {
        formRef.current?.resetFields();
        if (record) {
            formRef.current?.setFieldsValue({
                ...record,
                type: { value: record.typeEnum, label: record.type }
            });
            setAttributeRuleName(record.attributeRuleName);
        } else {
            setAttributeRuleName(null);
        }
    }

    const onEdit = () => {
        setViewMode(1)
    }

    const onOK = () => {
        formRef.current?.validateFields().then((values => {
            var request = {
                attributeRuleID: attributeRuleID,
                ...values,
                typeEnum: values.type.value,
                type: values.type.label,
            };
            Server.Post(URL.AttributeRule.SaveAttributeRule, request).then((response: any) => {
                if (response.isSuccess) {
                    setVisible(false);
                    reLoad();
                    message.success('保存成功');
                } else {
                    message.warning(response.returnMsg);
                }
            })
        })).catch((info: any) => {
            console.log(info);
        });
    }

    const onCancel = () => {
        setVisible(false);
    }
    return <Modal
        maskClosable={false}
        title={'属性规则[' + (attributeRuleName ?? 'NULL') + ']'}
        width={600}
        visible={visible}
        footer={<>
            <Space>
                {viewMode == 2 ? <Button onClick={onEdit} type={'primary'}>编辑</Button> : <></>}
                {viewMode != 2 ? <Button onClick={onOK} type={'primary'}>保存</Button> : <></>}
                <Button onClick={onCancel}>关闭</Button>
            </Space>
        </>}
        onOk={onOK}
        onCancel={onCancel}
        bodyStyle={{ padding: '10px' }}>
        <Form ref={formRef}
            labelCol={{ flex: '105px' }}
            labelWrap
            scrollToFirstError={true}>
            <Row>
                <Col span={24}>
                    <Form.Item style={{ marginBottom: '5px' }} name={'type'} label={'规则类型'}
                        initialValue={null}
                        rules={[{ required: true, message: '请选择规则类型' }]}>
                        <Select disabled={viewMode != 0}
                            style={{ width: '100%' }}
                            labelInValue
                            defaultValue={0}
                            onChange={(value: any) => {
                                formRef.current?.setFieldValue('attributeRuleName', value.label ?? '');
                            }}
                            options={[
                                { value: 0, label: '比价产品批次属性' },
                            ]}
                            placeholder={'请选择属性规则类型'} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item style={{ marginBottom: '5px' }} name={'attributeRuleName'} label={'规则名称'}
                        initialValue={''}
                        rules={[{ required: true, message: '请输入规则名称' }]}>
                        <Input disabled={viewMode == 2} style={{ width: '100%' }} placeholder={'请输入规则名称'} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item style={{ marginBottom: '5px' }} name={'remark'} label={'规则描述'} initialValue={''}>
                        <Input disabled={viewMode == 2} style={{ width: '100%' }} placeholder={'请输入属性规则描述'} />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    </Modal>
})
export default AttributeRuleEdit;